goog.provide("shadow.js.shim.module$src$svg$objects$megaphone_svg");
goog.provide("module$shadow_js_shim_module$src$svg$objects$megaphone_svg");
shadow.js.shim.module$src$svg$objects$megaphone_svg = shadow.js.nativeProvides["src/svg/objects/megaphone.svg"] = shadow$bridge("src/svg/objects/megaphone.svg");
module$shadow_js_shim_module$src$svg$objects$megaphone_svg.default = shadow.js.shim.module$src$svg$objects$megaphone_svg;
